export const Errors = [
    { path: '/:pathMatch(.*)*', redirect: '/404' },
    {
        path: '/404',
        name: '404',
        meta: { layout: 'auth' },
        component: () => import('@/views/errors/404')
    }
]